<div class="grid-x" *ngIf="domainType === 'COUNTRY_CODE'">
  <div class="cell large-4 medium-6 small-6"><label>Country Name:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text" [ngClass]="change| defineDomainViewCss: 'countryName': 'metadata'">
    {{tldMetadata?.countryName| displayValueFromChange :'countryName': change :'metadata'}}
  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Type:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text"> {{domainType | metadataHelper}} </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Status:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text"> {{domainStatus}} </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Description:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text multi-line" [ngClass]="change| defineDomainViewCss: 'description': 'metadata'">
    {{tldMetadata?.description| displayValueFromChange :'description': change :'metadata'}}

  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Special Instructions:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text multi-line" [ngClass]="change| defineDomainViewCss: 'specialInstructions': 'metadata'">
    {{tldMetadata?.specialInstructions| displayValueFromChange :'specialInstructions': change :'metadata'}}

  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>IANA Code:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text" [ngClass]="change| defineDomainViewCss: 'ianaCode': 'metadata'">
    {{tldMetadata?.ianaCode| displayValueFromChange :'ianaCode': change :'metadata'}}

  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Special Review:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text" [ngClass]="change| defineDomainViewCss: 'specialReview': 'metadata'">
    {{tldMetadata?.specialReview| displayValueFromChange :'specialReview': change :'metadataBoolean'}}

  </div>
</div>
<div class="grid-x">
  <div class="cell large-4 medium-6 small-6"><label>Caretaker:</label></div>
  <div class="cell medium-6 large-8 small-6 bold-text" [ngClass]="change| defineDomainViewCss: 'caretaker': 'metadata'">
    {{tldMetadata?.caretaker| displayValueFromChange :'caretaker': change :'metadataBoolean'}}

  </div>
</div>
<div class="grid-x">
  <div class="cell medium-6 large-4 small-6"><label>Phaseout:</label></div>
  <div class="cell medium-4 large-6 small-4 bold-text" [ngClass]="change| defineDomainViewCss: 'phaseout': 'metadata'">
    {{(tldMetadata?.phaseout | commonDate :true)| displayValueFromChange :'phaseout': change :'metadata'}}
  </div>
</div>
<div class="grid-x last-update-button-section">
  <label>{{lastchange | lastChange}}</label>
  <button *ngIf="!viewMode" class="iana-button" name="edit" id="update" (click)="onEdit()">Modify</button>
</div>


